import { fire } from '../config/firebase.config';
import { MESSAGE_TYPES as msg } from "../utils/js/constants";

const hasSessionUser = () => sessionStorage.getItem('user');

/**
 * @returns {Promise<firebase.user>}
 */
const hasUser = () => {
    return new Promise((resolve) => {
        fire.auth().onAuthStateChanged((user) => {
            resolve(user);
        });
    })
}

const checkAuthentication = async () => {
    const user = await hasUser();

    if (user) {
        await user.getIdToken(true);
        sessionStorage.setItem('user', JSON.stringify(user));
    } else {
        sessionStorage.removeItem('user');
    }

    return JSON.parse(sessionStorage.getItem('user'));
}

const handleLogout = () => {
    sessionStorage.removeItem('user');
    return fire
        .auth()
        .signOut()
        .then(() => ({
            message: msg.LOGOUT_SUCCESS, result: null, error: null
        }))
        .catch((error) => ({
            message: msg.LOGOUT_ERROR, result: null, error: error
        }));
}

const handleLoginFirebase = (email, password) => {
    const errorMessages = {
        "auth/invalid-email": 'email invalido!',
        "auth/user-disabled": 'Usuario desabilitado!',
        "auth/user-not-found": 'Usuario nao encontrado!',
        "auth/wrong-password": 'usuario ou senha invalido',
        "auth/too-many-requests": 'Muitas requisições em curto periodo de tempo',
    }

    return fire
        .auth()
        .signInWithEmailAndPassword(email, password)
        .then(res => {
            sessionStorage.setItem('user', JSON.stringify(res.user));
            return { message: msg.LOGIN_SUCCESS, result: res, error: null };
        })
        .catch(err => {
            return { message: msg.LOGIN_ERROR, result: null, error: errorMessages[err.code] }
        });
}

export { hasSessionUser, checkAuthentication, handleLoginFirebase, handleLogout };
